// `toLocaleString()` follows the process locale on a server and the browser's on the
// client, so the same number renders as 1,234 in one and 1.234 in the other. The app
// is English throughout, so the grouping is pinned rather than negotiated.
const formatter = new Intl.NumberFormat('en-US')

export default function formatCount(value) {
    return formatter.format(Number(value) || 0)
}
